import { leadershipCardsData, bgGradientStyle, bgwhiteStyle } from "./consts";

const LeadershipCards = () => {
  return (
    <>
      {leadershipCardsData.map((card, idx) => {
  const isLast = idx === leadershipCardsData.length - 1; // check last card
  const groupStyle = card.id === 8 ? bgwhiteStyle : card.gradientBg ? bgGradientStyle : bgwhiteStyle;

  return (
    <div
      key={card.id}
      className="flex flex-col items-center p-6 bg-gray-100"
      style={groupStyle}
    >
      <div
        className={`flex flex-col md:flex-row max-w-6xl bg-white rounded-xl p-4 border border-gray-300 overflow-hidden ${
          isLast ? "lg:mb-50" : ""
        }`}
      >
        {/* Image side */}
        <div
          className={`w-full md:w-1/3 flex items-start justify-center bg-gradient-to-br from-white to-gray-50 p-6 ${
            card.reverseLayout ? "order-1 md:order-2" : "order-1 md:order-1"
          }`}
        >
          <div className="relative">
            <div
              className={`absolute -top-3 ${
                card.reverseLayout ? "-right-3" : "-left-3"
              } w-full h-full border-4 border-[#d0e2e2] rounded-lg`}
            ></div>
            <img
              src={card.imgSrc}
              alt={card.imgAlt}
              className="relative z-10 rounded-lg"
            />
          </div>
        </div>

        {/* Text side */}
        <div
          className={`w-full md:w-2/3 p-4 ${
            card.reverseLayout ? "order-2 md:order-1" : "order-2 md:order-2"
          }`}
        >
          <h2 className="text-lg font-semibold text-gray-900">{card.name}</h2>
          <p className="text-sm text-gray-500 mb-4">{card.title}</p>
          <p className="text-gray-700 text-sm text-justify leading-relaxed mb-4 lg:w-[600px]">
            {card.description1}
          </p>
          {card.description2 && (
            <p className="text-gray-700 text-sm text-justify leading-relaxed mb-4 lg:w-[600px]">
              {card.description2}
            </p>
          )}
        </div>
      </div>
    </div>
  );
})}

    </>
  );
};

export default LeadershipCards;
